$shm_hitalama_map_widget_float_code_sql $shm_hitalama_map_widget_float_code_js
	code_content /
		<= Codes $mol_list
			sub /
				<= Textarea_sql $mol_textarea
					hint \sql
					sidebar_showed true
					value? <=> sql? \
					spellcheck false
				<= Textarea
		<= Bench $shm_hitalama_map_widget_float_code_bench
			widget <= widget
			map <= map
			Map_page <= Map_page
			run <= run null
			Process <= Process $shm_hitalama_process_view
				method_name \run
